import { Input } from 'common/InputForm';
import NotFound from 'common/NotFound';
import React, { useState } from 'react'
import { RiHandCoinFill } from 'react-icons/ri';
import { updateDeliveryStatusApi } from 'services/masterApi';


const SetCoinValue = ({ coinsList = [], onHide, setCoinsList = () => { }, getCoinsList = () => { } }) => {
    const [loadingId, setLoadingId] = useState(null);

    const handleValueChange = (newValue, id) => {
        const validValue = newValue.replace(/[^0-9]/g, '');
        const updatedList = coinsList.map(item =>
            item._id === id ? { ...item, value: validValue } : item
        );
        setCoinsList(updatedList);
    };
    return (
        <div className="table-container">
            <table className="table custom_table">
                <thead>
                    <tr>
                        <th className="nowrap text-center">Amount</th>
                        <th className="nowrap text-center">No. Of Coins</th>
                        <th className="nowrap text-center">Action</th>
                    </tr>
                </thead>

                <tbody>
                    {coinsList && coinsList.length > 0 ? (
                        coinsList?.map((data, index) => {
                            return (
                                // <tr key={index}>
                                //     <td className="nowrap text-center">
                                //         {/* {findSerialNumber(index, activePage, limit)} */}
                                //         {index + 1}
                                //     </td>
                                //     <td className="nowrap text-center">time</td>
                                //     <td className="nowrap text-center">

                                //     </td>
                                // </tr>
                                <tr key={index}>
                                    <td className="nowrap text-center">
                                        {/* {findSerialNumber(index, activePage, limit)} */}
                                        {data?.title}
                                    </td>
                                    <td className="nowrap text-center">
                                        <Input
                                            type="text"
                                            className='w-25 nowrap text-center'
                                            value={data?.value}
                                            onChange={(e) => handleValueChange(e.target.value, data?._id)}
                                            maxLength={9}
                                        />
                                    </td>
                                    <td className="nowrap text-center">
                                        <button
                                            type="button"
                                            // ref={loadingId === data?._id && buttonLoader}
                                            disabled={loadingId === data?._id}
                                            className="button"
                                            onClick={() => updateDeliveryStatusApi(
                                                data?._id,
                                                null, // status,
                                                data?.value,
                                                null,//setButtonLoader,
                                                null,//modalClose
                                                null,//ApiRefresh,
                                                null,//List,
                                                null, //setList
                                                setLoadingId//setLoadingId
                                            )}
                                        >
                                            {/* Change value */}
                                            {loadingId === data?._id ? "Loading..." : "Change value"}
                                        </button>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <NotFound
                            cols={3}
                            msg={"Coins Not Found"}
                            onHide={onHide}
                            icon={<RiHandCoinFill />}
                        />
                    )}
                </tbody>
            </table>
        </div>
    )
}

export default SetCoinValue